// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-choose {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-top: 10px;\n}\n.label-choose .info-title {\n  width: 100px;\n  font-weight: bold;\n}\n.label-choose .scroll {\n  max-height: 500px;\n  overflow-y: auto;\n  width: calc(100% - 100px);\n  margin-left: 5%;\n}\n.label-choose .label-group {\n  margin-bottom: 20px;\n}\n.label-choose > :nth-child(2) {\n  margin-left: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
